export interface CaseItem {
  id: string;
  category: string;
  categoryEn: string;
  title: string;
  subtitle: string;
  location: string;
  area: string;
  duration: string;
  year: string;
  coverImg: string;
  detailImgs: string[];
  background: string;
  problem: string[];
  solution: string[];
  highlight: string[];
  result: string;
  testimonial: string;
  testimonialAuthor: string;
  testimonialRole: string;
}

export const caseCategories = [
  { key: 'all', label: '全部案例' },
  { key: '餐飲空間', label: '餐飲空間' },
  { key: '零售門市', label: '零售門市' },
  { key: '辦公空間', label: '辦公空間' },
  { key: '診所醫美', label: '診所醫美' },
  { key: '展示接待', label: '展示接待' },
];

export const casesData: CaseItem[] = [
  {
    id: 'rihe-restaurant',
    category: '餐飲空間',
    categoryEn: 'F&B',
    title: '日禾和食',
    subtitle: '品牌禪意日式餐廳空間設計',
    location: '台北市信義區',
    area: '180坪',
    duration: '14週',
    year: '2023',
    coverImg: 'https://readdy.ai/api/search-image?query=elegant%20japanese%20zen%20restaurant%20interior%20design%20warm%20wood%20stone%20floor%20soft%20ambient%20lighting%20peaceful%20dining%20commercial%20space%20neutral%20warm%20tones%20minimalist%20high-end&width=1200&height=800&seq=case_cover001&orientation=landscape',
    detailImgs: [
      'https://readdy.ai/api/search-image?query=japanese%20restaurant%20dining%20area%20warm%20wood%20interior%20stone%20wall%20soft%20pendant%20lights%20elegant%20table%20setting%20serene%20atmosphere%20commercial%20design&width=800&height=600&seq=case_d001a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=japanese%20restaurant%20entrance%20reception%20dark%20wood%20floor%20zen%20decor%20warm%20lighting%20minimalist%20elegant%20commercial%20interior&width=800&height=600&seq=case_d001b&orientation=landscape',
      'https://readdy.ai/api/search-image?query=japanese%20private%20dining%20room%20tatami%20style%20wood%20panels%20soft%20light%20intimate%20atmosphere%20luxury%20restaurant%20interior&width=800&height=600&seq=case_d001c&orientation=landscape',
    ],
    background: '日禾和食是一個深耕台北信義區十年的日式料理品牌，因原有空間風格老舊、缺乏品牌識別，業績近年逐漸下滑，業主決定透過全面翻新重新奠定品牌定位。',
    problem: [
      '舊空間風格雜亂，無法清楚傳達「日式禪意」品牌調性',
      '用餐動線不順暢，翻桌效率低，座位利用率不佳',
      '包廂區光線昏暗且隔音不足，影響高消費客群體驗',
      '品牌視覺與空間設計風格脫節，難以留住目標客群',
    ],
    solution: [
      '以「侘寂美學」為設計核心，大量運用石材、實木與燈光層次打造禪意氛圍',
      '重新規劃用餐動線，設置明確的主通道與候位區，提升翻桌效率約25%',
      '包廂區採用隔音牆板並設計獨立調光系統，強化私密性與高端感',
      '統一品牌色彩語彙，從入口設計到餐具選搭全面整合品牌視覺識別',
    ],
    highlight: ['侘寂石材主牆', '可調光包廂系統', '優化動線配置', '品牌視覺整合'],
    result: '翻新後三個月，日禾和食的翻桌率提升30%，Instagram打卡分享量增加4倍，高端包廂預訂率滿載，品牌整體知名度顯著提升。',
    testimonial: '心旅商研深刻理解我們品牌的靈魂，他們不只是執行設計，而是真正協助我們重新定義了品牌空間的語言。完工後的反應遠超預期。',
    testimonialAuthor: '陳品妤',
    testimonialRole: '日禾和食 創辦人',
  },
  {
    id: 'zhixuan-retail',
    category: '零售門市',
    categoryEn: 'Retail',
    title: '質選良品',
    subtitle: '生活選物品牌旗艦店規劃設計',
    location: '台中市西區',
    area: '90坪',
    duration: '10週',
    year: '2023',
    coverImg: 'https://readdy.ai/api/search-image?query=modern%20lifestyle%20boutique%20retail%20store%20interior%20design%20clean%20white%20walls%20wooden%20display%20shelves%20soft%20spotlight%20commercial%20minimalist%20space%20premium%20goods%20display%20elegant&width=1200&height=800&seq=case_cover002&orientation=landscape',
    detailImgs: [
      'https://readdy.ai/api/search-image?query=lifestyle%20select%20shop%20display%20area%20open%20shelving%20natural%20wood%20white%20walls%20warm%20accent%20light%20product%20showcase%20minimalist%20retail%20design&width=800&height=600&seq=case_d002a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=boutique%20retail%20checkout%20counter%20marble%20top%20warm%20wood%20panel%20soft%20lighting%20clean%20elegant%20commercial%20interior%20design&width=800&height=600&seq=case_d002b&orientation=landscape',
      'https://readdy.ai/api/search-image?query=retail%20store%20fitting%20room%20area%20soft%20curtain%20warm%20light%20mirror%20minimalist%20clean%20premium%20shopping%20experience%20interior&width=800&height=600&seq=case_d002c&orientation=landscape',
    ],
    background: '質選良品是台中在地生活選物品牌，以策展型選品聞名，但舊有門市空間格局零碎，展示邏輯混亂，無法有效引導消費者探索產品，導致客單價偏低。',
    problem: [
      '空間格局零碎，缺乏明確的展示邏輯與引導動線',
      '燈光品質差，無法凸顯選品質感，影響購物意願',
      '試用區與結帳區位置不合理，造成消費流程斷點',
      '品牌形象與實體空間落差大，忠實客感到失望',
    ],
    solution: [
      '以「策展型零售」為設計概念，設計清晰的主動線與品類展示區',
      '引入多層次軌道燈光系統，精準照射每件選品，提升商品魅力度',
      '重新配置試用體驗區與結帳台位置，讓消費旅程流暢完整',
      '統一材料語彙：白橡木、奶油色牆面、石材檯面，呈現高質感品牌氛圍',
    ],
    highlight: ['策展型動線設計', '多層次燈光系統', '品類分區展示', '體驗流程優化'],
    result: '改裝後首月業績成長45%，顧客平均停留時間從8分鐘延長至22分鐘，客單價提升28%，品牌社群曝光量大幅增加。',
    testimonial: '空間改裝後，我們的客人會主動在店內探索，停留時間明顯變長，客單價也提升了很多。這正是我們一直希望空間能做到的事。',
    testimonialAuthor: '林宗翰',
    testimonialRole: '質選良品 總監',
  },
  {
    id: 'lumia-clinic',
    category: '診所醫美',
    categoryEn: 'Medical',
    title: 'Lumia 醫美診所',
    subtitle: '高端品牌診所空間規劃設計',
    location: '台北市大安區',
    area: '65坪',
    duration: '8週',
    year: '2024',
    coverImg: 'https://readdy.ai/api/search-image?query=luxury%20medical%20aesthetic%20clinic%20interior%20design%20marble%20reception%20desk%20soft%20warm%20lighting%20clean%20white%20walls%20premium%20healthcare%20space%20sophisticated%20elegant%20atmosphere&width=1200&height=800&seq=case_cover003&orientation=landscape',
    detailImgs: [
      'https://readdy.ai/api/search-image?query=medical%20aesthetic%20clinic%20waiting%20lounge%20luxury%20sofa%20marble%20wall%20soft%20ambient%20light%20clean%20elegant%20premium%20healthcare%20interior%20design&width=800&height=600&seq=case_d003a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=medical%20clinic%20consultation%20room%20clean%20white%20minimal%20furniture%20soft%20light%20professional%20calming%20atmosphere%20high-end%20medical%20interior&width=800&height=600&seq=case_d003b&orientation=landscape',
      'https://readdy.ai/api/search-image?query=aesthetic%20clinic%20treatment%20room%20clean%20minimalist%20warm%20lighting%20luxury%20medical%20equipment%20private%20intimate%20professional%20space&width=800&height=600&seq=case_d003c&orientation=landscape',
    ],
    background: 'Lumia 醫美診所為新成立的高端醫美品牌，創辦人希望打造有別於一般診所冰冷感的溫暖高端空間，以空間形象建立品牌公信力並吸引高消費族群。',
    problem: [
      '一般診所空間過於冰冷，無法傳達高端品牌應有的質感與溫度',
      '候診區設計單調，客人等待體驗差，影響整體品牌印象',
      '診療室與諮詢室之間動線規劃不當，隱私保護不足',
      '品牌視覺識別未能在空間中有效延伸呈現',
    ],
    solution: [
      '以「奢華靜謐」為主題，運用大理石、米白色系與金屬收邊打造高端氛圍',
      '候診區設計為品牌沙龍風格，提供飲品服務區與精品陳列牆，提升等待體驗',
      '獨立動線設計確保每位患者進出診間的隱私，同時優化醫護人員工作動線',
      '將品牌識別系統（色彩、字體、Logo）完整融入空間各接觸點',
    ],
    highlight: ['品牌沙龍候診區', '隱私動線設計', '大理石品牌主牆', '全空間品牌整合'],
    result: '開幕後兩個月即達預期業績目標，預約滿診，社群媒體自主分享率極高，品牌定位成功建立，多家媒體主動採訪報導。',
    testimonial: '診所的空間完全超越了我的期望。每一位進來的客人都說感覺不像在看診，更像是在享受一種高端服務。這正是我想要的品牌感受。',
    testimonialAuthor: 'Dr. 張薇庭',
    testimonialRole: 'Lumia 醫美診所 院長',
  },
  {
    id: 'nova-office',
    category: '辦公空間',
    categoryEn: 'Office',
    title: 'NOVA 創意工作室',
    subtitle: '品牌創意公司辦公空間設計',
    location: '台北市松山區',
    area: '120坪',
    duration: '12週',
    year: '2024',
    coverImg: 'https://readdy.ai/api/search-image?query=modern%20creative%20studio%20office%20interior%20design%20open%20workspace%20natural%20light%20exposed%20concrete%20ceiling%20warm%20wood%20furniture%20collaborative%20zone%20brand%20agency%20space&width=1200&height=800&seq=case_cover004&orientation=landscape',
    detailImgs: [
      'https://readdy.ai/api/search-image?query=creative%20agency%20open%20office%20workspace%20modern%20design%20wood%20desks%20industrial%20ceiling%20natural%20light%20warm%20accent%20colors%20collaborative%20professional%20atmosphere&width=800&height=600&seq=case_d004a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=office%20meeting%20room%20glass%20wall%20modern%20conference%20table%20warm%20wood%20acoustic%20panels%20pendant%20lights%20professional%20creative%20interior%20design&width=800&height=600&seq=case_d004b&orientation=landscape',
      'https://readdy.ai/api/search-image?query=office%20lounge%20break%20room%20modern%20soft%20seating%20warm%20lighting%20plants%20creative%20workspace%20comfortable%20informal%20meeting%20area%20design&width=800&height=600&seq=case_d004c&orientation=landscape',
    ],
    background: 'NOVA 為一間快速成長的品牌創意公司，人員從15人擴編至45人，原有辦公室空間嚴重不敷使用，且舊空間形象無法反映公司的創意品牌定位，難以吸引優秀人才。',
    problem: [
      '人員急速擴編，空間配置嚴重不足，工作效率下降',
      '缺乏足夠的會議室與討論區，協作空間不足',
      '舊辦公室缺乏品牌感，難以展示公司創意實力給客戶及求職者',
      '員工休憩空間不足，影響工作士氣與留任率',
    ],
    solution: [
      '以「開放協作 + 聚焦專注」雙核心規劃空間，設置彈性工位與獨立專注區',
      '設計3間大小不同的玻璃會議室及2個非正式討論角落，滿足多樣協作需求',
      '以裸露天花、木質家具、品牌色彩牆面打造充滿創意感的工作環境',
      '設置質感茶水間與休憩角落，作為非正式交流與放鬆的品牌文化場域',
    ],
    highlight: ['彈性開放工位', '玻璃會議室系統', '品牌主題牆設計', '創意休憩空間'],
    result: '搬入新辦公室後，員工滿意度調查結果提升60%，面試邀約回覆率提高，並成功接獲兩個大型品牌客戶，客戶反映參觀辦公室後對公司信心大增。',
    testimonial: '新辦公室讓每個員工都感到驕傲，更讓每個來拜訪的客戶對我們刮目相看。空間本身已經在幫我們說故事、贏得信任。',
    testimonialAuthor: '陳俊宇',
    testimonialRole: 'NOVA 創意工作室 執行長',
  },
  {
    id: 'horizon-showroom',
    category: '展示接待',
    categoryEn: 'Showroom',
    title: 'Horizon 品牌展廳',
    subtitle: '高端建材品牌旗艦展示空間',
    location: '台北市內湖區',
    area: '250坪',
    duration: '16週',
    year: '2023',
    coverImg: 'https://readdy.ai/api/search-image?query=luxury%20brand%20showroom%20exhibition%20space%20interior%20design%20high-end%20materials%20display%20architectural%20lighting%20dramatic%20open%20space%20sophisticated%20gallery%20style&width=1200&height=800&seq=case_cover005&orientation=landscape',
    detailImgs: [
      'https://readdy.ai/api/search-image?query=brand%20showroom%20main%20hall%20high%20ceiling%20dramatic%20spotlight%20stone%20material%20display%20luxury%20commercial%20exhibition%20space%20architectural%20design&width=800&height=600&seq=case_d005a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=material%20sample%20display%20wall%20showroom%20elegant%20organized%20showcase%20marble%20wood%20metal%20samples%20professional%20design%20studio%20interior&width=800&height=600&seq=case_d005b&orientation=landscape',
      'https://readdy.ai/api/search-image?query=VIP%20reception%20lounge%20showroom%20luxury%20sofa%20coffee%20table%20warm%20light%20exclusive%20private%20meeting%20area%20brand%20experience%20space&width=800&height=600&seq=case_d005c&orientation=landscape',
    ],
    background: 'Horizon 為高端建材品牌，代理多個歐洲頂級石材與木飾面品牌。舊展廳空間呈現方式傳統，無法讓採購客戶感受到材料的高端質感，直接影響成交率。',
    problem: [
      '舊展廳以量取勝，材料堆砌感重，無法傳達高端品牌應有的精緻感',
      '缺乏情境式展示，客戶難以想像材料實際應用在空間中的效果',
      '無專屬VIP接待區，難以服務高端採購客群與設計師',
      '展廳照明品質差，大理石、木皮等高端材料無法呈現最佳視覺效果',
    ],
    solution: [
      '以「美術館展覽」概念重新設計，讓每組材料都有獨立的「舞台」呈現',
      '設計多個情境場景區，將材料嵌入實際空間場景中展示，提升購買想像力',
      '規劃獨立VIP接待與洽談區，配備精品氛圍，讓高端客戶有尊貴體驗',
      '全展廳導入可調色溫的高演色性燈光系統，精準呈現每種材料的最佳質感',
    ],
    highlight: ['美術館展示概念', '情境場景展示區', 'VIP 接待洽談室', '高演色燈光系統'],
    result: '新展廳開幕後，設計師參訪量增加3倍，成交轉化率提升40%，並榮獲業界媒體「年度最佳品牌展廳」報導，成為業界指標性空間。',
    testimonial: '展廳改造後，每位設計師走進來的反應都是驚豔。我們的材料不再只是樣本，而是真正活在空間裡。成交率的提升只是結果，品牌形象的躍升才是最大的收穫。',
    testimonialAuthor: '吳品蓁',
    testimonialRole: 'Horizon 建材 品牌總監',
  },
  {
    id: 'lekafe-chain',
    category: '餐飲空間',
    categoryEn: 'F&B',
    title: 'Le Kafé 精品咖啡',
    subtitle: '連鎖精品咖啡品牌旗艦店',
    location: '高雄市前金區',
    area: '55坪',
    duration: '7週',
    year: '2024',
    coverImg: 'https://readdy.ai/api/search-image?query=premium%20specialty%20coffee%20shop%20interior%20design%20warm%20wood%20counter%20exposed%20brick%20wall%20pendant%20lights%20cozy%20atmosphere%20brand%20cafe%20minimalist%20elegant&width=1200&height=800&seq=case_cover006&orientation=landscape',
    detailImgs: [
      'https://readdy.ai/api/search-image?query=specialty%20coffee%20shop%20bar%20counter%20professional%20espresso%20machine%20warm%20wood%20paneling%20marble%20counter%20top%20dramatic%20pendant%20lighting%20elegant%20commercial%20design&width=800&height=600&seq=case_d006a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=cafe%20seating%20area%20window%20seats%20warm%20wood%20table%20natural%20light%20cozy%20atmosphere%20premium%20coffee%20shop%20minimalist%20interior%20design&width=800&height=600&seq=case_d006b&orientation=landscape',
      'https://readdy.ai/api/search-image?query=coffee%20shop%20branding%20wall%20logo%20signage%20clean%20minimalist%20warm%20lighting%20brand%20identity%20cafe%20interior%20design%20premium%20atmosphere&width=800&height=600&seq=case_d006c&orientation=landscape',
    ],
    background: 'Le Kafé 為南部精品咖啡品牌，計畫開設品牌旗艦店作為後續拓展連鎖的標準樣板。業主希望在有限坪數內，打造出能夠清晰傳達品牌個性並吸引目標客群的旗艦空間。',
    problem: [
      '坪數有限（55坪），需同時兼顧吧台作業效率與顧客舒適座位數',
      '品牌識別尚未在空間中形成清晰印象，無法與競爭對手差異化',
      '舊址裝修不可拆除部分多，設計限制大，需找到兼容解法',
      '預算有限，需在預算內創造最大的品牌視覺衝擊力',
    ],
    solution: [
      '精確規劃吧台工作流程動線，在有限空間內最大化座位數（32席）',
      '以「深焙木色 × 霧面金屬 × 品牌磨砂玻璃」建立鮮明品牌材料語彙',
      '保留原有水泥天花並作為設計語言，降低改裝成本，反而增添質感個性',
      '以品牌主牆與視覺識別系統為預算重點，創造高CP值的打卡性視覺焦點',
    ],
    highlight: ['高效吧台動線', '品牌材料語彙', '打卡主牆設計', '預算精準配置'],
    result: '開幕當天大排長龍，首週社群曝光突破10萬次，成為高雄話題性咖啡空間。旗艦店成功建立品牌標準，後續已複製設計DNA展開連鎖擴店計畫。',
    testimonial: '心旅商研完全理解我們小坪數、大品牌的需求。他們讓每一分預算都花得精準，打造出比我預期更有質感的空間，也讓我有信心繼續展店。',
    testimonialAuthor: '黃柏翔',
    testimonialRole: 'Le Kafé 精品咖啡 創辦人',
  },
  {
    id: 'muse-hotel-lobby',
    category: '展示接待',
    categoryEn: 'Showroom',
    title: 'Muse 精品旅宿',
    subtitle: '設計型精品旅館大廳接待空間',
    location: '台南市中西區',
    area: '110坪',
    duration: '11週',
    year: '2025',
    coverImg: 'https://readdy.ai/api/search-image?query=boutique%20hotel%20lobby%20reception%20interior%20design%20elegant%20warm%20lighting%20travertine%20stone%20floor%20custom%20front%20desk%20artistic%20sculpture%20neutral%20cream%20tones%20sophisticated%20luxury%20grand%20atmosphere&width=1200&height=800&seq=case_cover007&orientation=landscape',
    detailImgs: [
      'https://readdy.ai/api/search-image?query=boutique%20hotel%20lobby%20front%20desk%20check-in%20area%20marble%20counter%20dramatic%20floral%20arrangement%20warm%20ambient%20lighting%20cream%20walls%20luxury%20premium%20interior%20design%20refined&width=800&height=600&seq=case_d007a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=hotel%20lounge%20seating%20area%20artistic%20decor%20warm%20tones%20velvet%20sofa%20accent%20chairs%20side%20table%20soft%20lamp%20light%20sophisticated%20boutique%20interior%20relaxing&width=800&height=600&seq=case_d007b&orientation=landscape',
      'https://readdy.ai/api/search-image?query=boutique%20hotel%20corridor%20hallway%20warm%20pendant%20lights%20textured%20wall%20panel%20wood%20floor%20elegant%20intimate%20atmosphere%20luxury%20hospitality%20interior%20design%20calm&width=800&height=600&seq=case_d007c&orientation=landscape',
    ],
    background: 'Muse 精品旅宿由台南在地藝文團隊創辦，主打「藝術生活化」體驗，業主希望從踏入大廳的第一秒起，就讓旅客感受到截然不同於連鎖飯店的獨特品牌個性。',
    problem: [
      '原有建築格局方正單調，缺乏任何視覺焦點或驚喜感',
      '品牌「藝術生活化」的核心主張，無法從空間中感受到',
      '接待流程動線不直覺，旅客入住效率低，第一印象不佳',
      '公共空間缺乏留客誘因，旅客入住後直接上房，互動率低',
    ],
    solution: [
      '以大型藝術裝置為大廳核心視覺，與台南在地藝術家合作訂製主題雕塑',
      '運用洞石、手刮灰泥牆、柚木地板建立溫潤的南台灣在地材料語彙',
      '重新設計接待動線，設置直覺性引導標示，縮短入住等待感',
      '規劃「旅宿圖書室」與「藝文小品展區」，創造旅客自然停留的公共場所',
    ],
    highlight: ['在地藝術裝置', '洞石與手刮泥牆', '藝文停留場域', '南台灣材料語彙'],
    result: '開幕後 Google 評分達 4.9 分，旅客入住後公共空間停留率提升至 65%，多家旅遊媒體評選為「台南最具設計感精品旅宿」，訂房率於三個月內達滿載。',
    testimonial: '我們的旅客常說，光是在大廳坐著就值回票價了。心旅商研把我們對「藝術生活化」的想像，真實地刻進了每一個空間細節裡。',
    testimonialAuthor: '鄭雅筑',
    testimonialRole: 'Muse 精品旅宿 共同創辦人',
  },
  {
    id: 'greenform-office',
    category: '辦公空間',
    categoryEn: 'Office',
    title: 'GreenForm 永續辦公室',
    subtitle: '綠色永續企業品牌辦公空間',
    location: '新竹市東區',
    area: '85坪',
    duration: '9週',
    year: '2025',
    coverImg: 'https://readdy.ai/api/search-image?query=sustainable%20biophilic%20office%20interior%20design%20living%20green%20wall%20abundant%20indoor%20plants%20natural%20wood%20furniture%20warm%20soft%20lighting%20open%20workspace%20eco%20friendly%20corporate%20space%20serene&width=1200&height=800&seq=case_cover008&orientation=landscape',
    detailImgs: [
      'https://readdy.ai/api/search-image?query=biophilic%20office%20workspace%20green%20living%20wall%20moss%20panel%20natural%20wood%20desk%20abundant%20indoor%20plants%20warm%20light%20open%20plan%20sustainable%20interior%20design%20modern&width=800&height=600&seq=case_d008a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=eco%20office%20meeting%20room%20reclaimed%20wood%20table%20green%20plants%20glass%20wall%20natural%20materials%20sustainable%20design%20warm%20lighting%20collaborative%20space%20professional&width=800&height=600&seq=case_d008b&orientation=landscape',
      'https://readdy.ai/api/search-image?query=office%20break%20lounge%20area%20natural%20rattan%20furniture%20lush%20plants%20pendant%20lights%20warm%20tones%20sustainable%20materials%20cozy%20relaxing%20corporate%20interior%20design%20calm&width=800&height=600&seq=case_d008c&orientation=landscape',
    ],
    background: 'GreenForm 為新竹新興永續材料科技公司，自我定位為「讓地球更好的企業」。在搬遷新辦公室之際，業主希望辦公空間本身就是品牌永續理念最有力的示範場域。',
    problem: [
      '品牌核心價值「永續環保」在舊辦公室空間中完全缺席，品牌一致性不足',
      '大量使用傳統建材，碳足跡高，與公司對外宣揚的永續主張相悖',
      '辦公環境封閉沉悶，缺乏自然採光與植栽，員工身心健康感受偏低',
      '無法有效利用辦公空間向合作夥伴與投資人展示品牌理念',
    ],
    solution: [
      '導入「仿生辦公」設計概念，以大型苔蘚主牆與植生牆作為空間核心視覺',
      '全面採用 FSC 認證木材、回收金屬與低VOC塗料，實踐材料永續承諾',
      '拆除不必要隔間，引入最大化自然採光，搭配感應調光系統降低耗電',
      '設計「品牌展示走廊」，以視覺化方式呈現公司永續成果數據與產品應用',
    ],
    highlight: ['苔蘚植生主牆', 'FSC認證永續材料', '品牌展示走廊', '感應調光系統'],
    result: '辦公室竣工後獲得 LEED 銀級認證，員工健康滿意度提升 55%，多家 ESG 媒體主動採訪，更成為公司接待投資人時的最佳品牌說服工具，當年成功完成 A 輪募資。',
    testimonial: '我們的投資人走進辦公室後說：「這個空間就是你們最好的 pitch deck。」心旅商研把我們的品牌相信，變成了有形的空間語言，這份價值無法量化。',
    testimonialAuthor: '蔡明哲',
    testimonialRole: 'GreenForm 永續科技 執行長',
  },
];
